<template>
  <div style="width: 1000px">
    <a-form-item label="规则名称">
      <a-input
        v-model:value="initState.name"
        placeholder="请输入规则名称"
        :maxlength="100"
      ></a-input>
    </a-form-item>
    <a-form-item label="规则描述">
      <a-textarea
        v-model:value="initState.description"
        placeholder="请输入规则描述"
        :maxlength="500"
      ></a-textarea>
    </a-form-item>
    <a-form-item label="生效时间">
      <a-form-item style="display: inline-block;">
        <a-date-picker
          show-time
          v-model:value="initState.startDatetime"
          placeholder="开始时间"
          style="width: 200px;"
          :disabled-date="disabledStartDate"
        />
      </a-form-item>
      <span>
        ~
      </span>
      <a-form-item style="display: inline-block;">
        <a-date-picker
          v-model:value="initState.endDatetime"
          show-time
          placeholder="结束时间"
          style="width: 200px;"
          :disabled="initState.longTerm === 1"
        />
        (GMT+1)
      </a-form-item>
      <a-form-item style="display: inline-block; margin-left: 30px;">
        <a-checkbox
          :checked="initState.longTerm === 1"
          @change="onLongTermChange"
          >长期有效</a-checkbox
        >
      </a-form-item>
    </a-form-item>
    <a-form-item label="状态">
      <a-radio-group v-model:value="initState.enable">
        <a-radio :value="1">启用</a-radio>
        <a-radio :value="0">停用</a-radio>
      </a-radio-group>
    </a-form-item>
  </div>
  <div style="display: flex; justify-content: flex-end;">
    <a-space>
      <a-button type="primary" @click="next">下一步</a-button>
      <a-button
        @click="
          $router.push({
            path: '/PopupRuleList',
            query: {
              uniqueId: $route.query.uniqueId,
              siteId: initState.siteId,
              terminalId: initState.terminalId
            }
          })
        "
      >
        取消
      </a-button>
    </a-space>
  </div>
</template>

<script setup>
import dayjs from 'dayjs'
import { inject } from 'vue'
import { message } from 'ant-design-vue'

const now = dayjs()

const initState = inject('initState')

const disabledStartDate = current => {
  return current && current < now.startOf('day')
}

const onLongTermChange = event => {
  if (event.target.checked) {
    initState.endDatetime = null
  }
  initState.longTerm = event.target.checked ? 1 : 0
}

const next = () => {
  if (!initState.name) {
    return message.warn('请输入规则名称')
  }
  if (!initState.startDatetime) {
    return message.warn('请选择生效时间')
  }
  if (initState.longTerm !== 1) {
    if (initState.endDatetime) {
      if (initState.endDatetime < initState.startDatetime) {
        return message.warn('结束时间不能小于开始时间')
      }
    } else {
      return message.warn('请选择结束时间')
    }
  }
  console.log(message)
  initState.next()
}
</script>
